<template>
  <div class="medics">
    <h3>Médicos</h3>
    <div class="wrapper-listado">
      <div class="listado-header">
        <div class="accion-listado">
          <div class="action">
            <!-- <i class="fas fa-plus-circle"></i>
            <router-link :to="{name:'new-medic' }">Nuevo médico</router-link> -->
          </div>
        </div>
      </div>
      <div class="wrapper-body">
        <table class="table table-striped">
                 <thead>
              <th>Nombre
                </th>
                <th>
                  Especialidad
                  </th>
              </thead>
          <tbody>
     
            <tr v-for="medic in medics" v-bind:key="medic.wallet">
              <td>
                {{medic.name}}
              </td>
              <!-- <td>{{medic.addr}}</td> -->
              <td> {{medic.specliality}}</td>
              <!-- <td>{{medic.wallet}}</td> -->
              <!-- <td class="tools"> -->
                <!-- <router-link :to="{name: 'visit-data', params: { id: medic.address}}">
                              <i class="fas fa-notes-medical"> </i> Ver datos
                </router-link>-->
              <!-- </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
// import MedicsManager from "../managers/medicsManager";
import gun from '../managers/gun'
// import MedicsManager from '../managers/medicsManager'
export default {
  data() {
    return {
      medics: [],
      registrationContract: null,
      contractID:  process.env.MEDIC_REGISTRATION
    };
  },
  methods: {
    async refreshmedics() {
      console.log("vals")
      var medics = gun.get('main-user-list').once().map()
      medics.once(async (val) => {
        console.log(val)
        if (val != null && val.medic) {
        gun.user(val.pub).get("profile").on((profile) => {
                  val.specliality = profile.specliality 
        })
        this.medics.push(val)
        }

      })

    }
  },
  created() {
    // MedicsManager.GetMedicRegistrationContract( process.env.VUE_APP_MEDIC_REGISTRATION).then(async contract =>  {
    //   this.registrationContract = contract;
    //   var msg = await contract.methods.GetMedics();
    //   msg.call((i,data) => {
    //     for(var medic of data) {
    //       console.log(medic.pub)
    //       gun.user(medic.pub).get("profile").once(medicProfile => {
    //         console.log(medicProfile)
    //         if(medicProfile)
    //         this.medics.push(medicProfile)
    //       })
    //     }
    //   })
    // })
    // gun.get("medics-list").map().on((data) => {
    //   if(data != null) {
    //  this.medics.push(data)
    //   }
 
    // })
    // console.log(gun.user())
    // gun.get("medicsKeyring").get(gun.user().is.pub).once(console.log)
    this.refreshmedics()

  }
};
</script>
<style lang="scss" scoped>
</style>